module.exports = __webpack_public_path__ + "static/51-a0e8a6a23cb1fbdbdd138834bf019487.png";